// One RDP session per physical bot host.
// Google Remote Desktop blocks iframe embedding, so links open in a new tab.

export default [
  {
    key: 'tlv',
    label: 'תל אביב',
    url: 'https://remotedesktop.google.com/access/session/642a55e3-9841-e0e0-0ae3-4af00870f182',
  },
  {
    key: 'police',
    label: 'משטרה',
    url: 'https://remotedesktop.google.com/access/session/929ca26d-1083-0db3-8a84-022477b7265b',
  },
  {
    key: 'lolaAndOthers',
    label: 'שאר הבוטים',
    url: 'https://remotedesktop.google.com/access/session/58395a45-8d3d-73ea-d13a-b93b7c1ee9dd',
  },
];
